export default {"src":"/_next/static/image/public/images/flags/flag_45.084944b579ab2f80c025f88c3e83b201.svg","height":16,"width":24};